import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-payment-response-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './payment-response-modal.component.html',
  styleUrl: './payment-response-modal.component.scss'
})
export class PaymentResponseModalComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PaymentResponseModalComponent>
  ) {}

  closeModal() {
    this.dialogRef.close();
  }
}
